import CommonModal from '../CommonModal/CommonModal'
import './AccessModal.scss';
import {FormattedMessage} from "react-intl";
import {useAccess} from "../../hooks/useAccess";

const AccessModal = ({ isModalOpen, closeModal }) => {
  const {accessOptions, selectAccessOption} = useAccess();

  const handleSelectAccess = (option) => {
    selectAccessOption(option);
    closeModal();
  };

  const closeModalForDev = () => {
    if (process.env.NODE_ENV === 'development') {
      closeModal();
    }
  }

  return (
    <CommonModal
      isModalOpen={isModalOpen}
      className='AccessModal'
      noHeader={true}
    >
      <div className='header' onClick={closeModalForDev}>
        <FormattedMessage id='@access_modal_title' />
      </div>
      {
        accessOptions.map((option, i) => (
          <div className='centers' onClick={() => handleSelectAccess(option)} key={i}>
            {option.label}
          </div>
        ))
      }
    </CommonModal>
  );
}

export default AccessModal;
